<template>
  <v-card color="rgba(0, 0, 0, 0.5)">
    <v-card-title>
      <div class="d-flex">
        <p class="text-caption white--text font-weight-bold">API</p>
        <p class="text-caption white--text pl-2">
          {{ apiURL || 'http://localhost:8000/api/' }}
        </p>
      </div>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            :color="urlDiff ? 'warning' : 'primary'"
            dark
            small
            @click="$emit('openConfigDialog')"
          >
            <v-icon>mdi-power-plug-outline</v-icon>
          </v-btn>
        </template>
        <span v-if="urlDiff">{{ $t('login.warning-message') }}</span>
      </v-tooltip>
    </v-card-title>
    <v-card-text>
      <v-form v-model="formLoginValid" ref="form">
        <div>
          <v-text-field
            v-model.trim="form.username"
            :label="$t('login.placeholder.username')"
            type="text"
            :rules="formRules.usernameRules"
            dark
            @focusin="focused = !focused"
            @focusout="focused = !focused"
          ></v-text-field>
          <v-text-field
            v-model.trim="form.password"
            :label="$t('login.placeholder.password')"
            :type="showPass ? 'text' : 'password'"
            :rules="formRules.passwordRules"
            dark
            :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPass = !showPass"
            @focusin="focused = !focused"
            @focusout="focused = !focused"
          ></v-text-field>
        </div>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="teal lighten-1" dark @click="$emit('openGuestDialog')">
        <v-icon small left>mdi-login</v-icon>
        <div>{{ $t('labels.convidado') }}</div>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        color="success"
        class="ml-auto"
        @click="validate()"
        @shortkey="validate()"
        v-shortkey.once="focused ? ['enter'] : undefined"
        @focusin="focused = !focused"
        @focusout="focused = !focused"
      >
        <v-icon small left>mdi-login</v-icon>
        <div>{{ $t('labels.acessar') }}</div>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  data: () => {
    return {
      focused: false,
      showPass: false,
      form: {
        username: '',
        password: '',
      },
      formLoginValid: false,
    }
  },
  computed: {
    ...mapState('systemModule', ['apiURL']),
    urlDiff() {
      const urlApi = this.apiURL
        .substring(0, this.apiURL.lastIndexOf('.'))
        .replace(/[^0-9.]+/g, '')

      const urlHost = location.host
        .substring(0, location.host.lastIndexOf('.'))
        .replace(/[^0-9.]+/g, '')
      return urlApi !== urlHost
    },
    formRules() {
      const rules = {
        usernameRules: [
          (v) => !!v || this.$t('validation-messages.requiredField'),
          (v) =>
            v.length >= 4 ||
            this.$t('validation-messages.minLength', {
              quantidade: 4,
            }),
          (v) =>
            v.length <= 20 ||
            this.$t('validation-messages.maxLength', {
              quantidade: 20,
            }),
        ],
        passwordRules: [
          (v) => !!v || this.$t('validation-messages.requiredField'),
          (v) =>
            v.length >= 4 ||
            this.$t('validation-messages.minLength', {
              quantidade: 4,
            }),
        ],
      }

      return rules
    },
  },
  methods: {
    ...mapActions({
      loginUser: 'authModule/loginUser',
      showLoadingDialog: 'dialogModule/setShowLoadingDialog',
      setLoadingDialogMessage: 'dialogModule/setLoadingDialogMessage',
    }),
    async validate() {
      try {
        if (!this.$refs.form.validate()) throw this.$t('login.corrigir')

        this.setLoadingDialogMessage(this.$t('login.autenticando'))
        this.showLoadingDialog(true)

        let loginData = {}
        loginData.NOME = this.form.username.toUpperCase()
        loginData.password = this.form.password

        await this.loginUser(loginData)
        this.$toasted.success(this.$t('login.autenticado'))
        this.$router.push({ name: 'Home' })
      } catch (err) {
        let messageErr = ''
        if (
          err.lastIndexOf('Filial') !== -1 &&
          err.lastIndexOf('não permitida') !== -1
        ) {
          let list = JSON.parse(localStorage.getItem('LAST_USER_FILIAL'))
          let newList = list.filter(
            (element) => element.user != this.form.username.toUpperCase()
          )
          localStorage.setItem('LAST_USER_FILIAL', JSON.stringify(newList))
          messageErr = this.$t('login.tryAgain')
        }
        this.$toasted.error(err + messageErr, { duration: null })
      } finally {
        this.showLoadingDialog(false)
      }
    },
  },
}
</script>

<style></style>
